import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./baseSlice";
import intl from "../../i18n/intl";
import { toast } from "react-toastify";

const initialState = {
  data: [],
  record: null,
  requesting: false,
  error: null,
  action: null,
};

const customIntl = intl();

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    listRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "list";
      state.record = null;
    },
    listSuccess: (state, action) => {
      state.data = action.payload.response;
      state.requesting = false;
      state.error = null;
    },
    listFail: (state, action) => {
      state.data = [];
      state.requesting = false;
      state.error = action.payload;
    },
    updateStatusRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "update";
      const rec = state.data.find((r) => r.id === action.payload.id);
      if (rec) {
        rec.isEnabled = action.payload.status;
      }
    },
    updateStatusSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage(
          { id: "action_success" },
          {
            action: customIntl.formatMessage({ id: "update_performed" }),
            object: customIntl.formatMessage({ id: "notification" }),
          }
        )
      );
    },
    updateStatusFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
  },
});

export const {
  listFail,
  listRequest,
  listSuccess,
  updateStatusFail,
  updateStatusRequest,
  updateStatusSuccess,
} = notificationsSlice.actions;
export default notificationsSlice.reducer;
